import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { alpha } from '@material-ui/core/styles';

export const StyledLink = withStyles(theme => ({
    root: {
        color: '#fff',
        padding: "3px 12px 3px 0px",
        textDecoration: "none",

        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.light, 0.3),
        }
    },
}))(Link);

export default StyledLink;